import { themeColors } from "@hubrise/react-components"
import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  opacity: 1;
  transition: opacity 0.1s ease-out;
`

export const ActionText = styled.div`
  white-space: nowrap;
`

export const ActionLink = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${themeColors.primary};
  }
`
